import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
//cookies
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const ExpenseHistory = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [accounttypeId, setaccounttypeId] = useState(''); //account_type_id
	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
	const [glAccount, setGlAccount] = useState([]);
	const [grandTotal, setGrandTotal] = useState({"grand_total":0});
	const [downloadFlag, setDownloadFlag] = useState(false);
	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'expense_history_report', {
            params:{
				date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                 date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                 account_type_id: accounttypeId, 
                 jc_user_id_no: useridNo, 
			}
		})
		setPosts(result.data.data);
		if(result.data.data.length > 0){
			const grandTotal = result.data.data.pop();
			if(grandTotal.grand_total){
				setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
			}
		}
		setDataLoaded(true);
    }

	const data = async () => {
		// const result = await axios.get(
        //     process.env.REACT_APP_API_URL+'expense_history_report', {
        //     params:{
        //         date_from: '2015/01/01/', //format(dateRange.startDate, "yyyy/MM/dd/")
        //         date_to: '2016/12/01/',   //format(dateRange.endDate, "yyyy/MM/dd/")
        //         account_type_id: 37, 
        //         jc_user_id_no: 'DAVAOHQ',  
        //     }
        // })
        // setPosts(result.data.data);
		// if(result.data.data.length > 0){
		// 	const grandTotal = result.data.data.pop();
		// 	if(grandTotal.grand_total){
		// 		setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
		// 	}
		// }
		setDataLoaded(false);
		const glRes = await axios.get(process.env.REACT_APP_API_URL+'gl_account_type');
		// const allAccount = {
		//   id: "all",
		//   description: "All Accounts",
		//   branchidno: ""
		//   };
		// glRes.data.data.unshift(allAccount);
		console.log(glRes.data.data);
		setGlAccount(glRes.data.data);	
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const selectAccountProps = {
		options: glAccount,
		getOptionLabel: (option) => option.description + ' - ' + option.branchidno
	};

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const columns = [
		{
			name: "id",
			label: "ID",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "payto",
			label: "Pay To",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "expno",
			label: "Exp No",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "refno",
			label: "Reference #",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "trandate",
			label: "Tran Date",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "acctid",
			label: "Account ID",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "description",
			label: "Description",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "branchidno",
			label: "Branch ID #",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "iscv",
			label: "Is CV",
			// options: {
			// 	filter: false,
			// },
		},
		{
			name: "tamount",
			label: "Total Amount",
			options:{
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			},
		}
	];

	const options = {
		filter: true,
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this 
		downloadOptions: {
			filename : 'ExpenseHistoryReport.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Expense History Report</h4>
			</div>
			<div className="page-container">
			
				<div style={style}>

					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						<Grid item xs={12} sm={4}>
							{/* <Input style ={{marginTop: "23px"}}  placeholder="Account Type ID" inputProps={{ 'aria-label': 'account type id' }} onChange={e => setaccounttypeId(e.target.value)}/> */}
							<Autocomplete
                                        {...selectAccountProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
										style ={{marginTop: "-15px"}}
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Select GL Account"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												//prep_data.warehouse = JSON.stringify(newValue.id, null, ' ');
												//console.log(JSON.stringify(newValue.id, null, ' '));
												console.log(newValue.id);
												setaccounttypeId(newValue.id);
											}
										}}
                                    />
						</Grid>

						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "23px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={3} sm={1}>
							<Button style ={{marginTop: "23px"}}  variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>

						<Grid item xs={9} sm={12} md={12} lg={4} xl={5} style={{ display: "flex", justifyContent: "flex-end" }}>
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  style={{marginTop: '5px', marginLeft: '20px'}} 
								  id="outlined"
								  type="text"
								  value={grandTotal.grand_total}
								  variant="outlined"
								  label="Grand Total"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
							</Grid>

					</Grid>       

				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
						
								<div className="table-title">
									Expense History Report
								</div>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default ExpenseHistory;
